export default class ImageBankCtrl {
    constructor($scope, $q, $filter, $timeout, SweetAlert, ImageBank) {
        this._scope = $scope;
        this._q = $q;
        this._translator = $filter('translate');
        this._timeout = $timeout;

        this.imageBankRepo = ImageBank;
        this.sweetAlert = SweetAlert;

        this.imageBank = {
            visible: false,
            maximized: false,
            page: 1,
            pages: 0,
            directory: { id: 0 },
            editDir: false
        };

        this.infoActive = false;
        this.MAX_FILE_SIZE = 2048;
        this.VALID_FORMATS = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];

        this._scope.$on('imageBank:updateUI', () => {
            this.updateUI();
        });

        this._scope.$on('upload:images', () => {
            this.fetchImagesAndDirectories(1, this.imageBank.directory.id);
        });

        this._scope.$on('imageBank:dragOver', () => {
            if (! this.imageBank.imgMove) {
                this.imageBank.dragActive = true;
            }
        });

        this._scope.$on('imageBank:dragLeave', () => {
            this.imageBank.dragActive = false;
        });

        this.msgMap = {
            remove_img: ['IMAGE_BANK:FLASH:REMOVE_IMAGE_HEADER', 'IMAGE_BANK:FLASH:REMOVE_IMAGE_BODY'],
            delete_error: ['GLOBAL:FLASH:OOPS', 'GLOBAL:FLASH:DELETE_ERROR'],
            delete_dir: ['GLOBAL:FLASH:DELETE', 'IMAGE_BANK:FLASH:REMOVE_DIRECTORY_BODY'],
            dimension_err: ['IMAGE_BANK:FLASH:DIMENSIONS_CHANGED_HEADER', 'IMAGE_BANK:FLASH:DIMENSIONS_CHANGED_BODY'],
            mime_type_err: ['IMAGE_BANK:FLASH:MIME_TYPE_HEADER', 'IMAGE_BANK:FLASH:MIME_TYPE_BODY'],
            file_size_err: ['IMAGE_BANK:FLASH:FILE_SIZE_HEADER', 'IMAGE_BANK:FLASH:FILE_SIZE_BODY']
        };

        $(window).resize(() => {
            $timeout(() => {
                this.constructor.calcHeightForImageAndDirectoryContainer();
            }, 400);
        });

        $(document).keyup((e) => {
            if (e.keyCode == 27 && this.imageBank.visible && !this.infoActive) {
                this._scope.$broadcast('imageBank:close');
                this.imageBank.visible = false;
                $('body').css('overflow-y', 'inherit');
                this._scope.$apply(); // Close image bank on escape.
            }
        });

        this._scope.$on('imageBank:toggle', (event, full) => {
            this.toggle(full);
        });

        this._scope.$on('imageBank:moveImage', (event, data) => {
            this.move(data.imgId, data.dirId);
        });

        this._scope.$on('imageBank:uploadImages', (event, data) => {
            this.validateFiles(data.files).then(() => {
                if (this.imageBank.validated.length > 0) {
                    let directoryId = data.dirId ? data.dirId : this.imageBank.directory.id;

                    this.imageBankRepo.store(this.imageBank.validated, directoryId).then(() => {
                        this.fetchImagesAndDirectories(1, this.imageBank.directory.id);
                    }).catch((error) => {
                        if (error.status == 415) {
                            this.generateMessage('mime_type_err', 'error');
                        }
                    })
                }
            });

            this.imageBank.dragActive = false;
        });

        this._scope.$on('imageBank:dragStart', () => {
            if (! this.imageBank.imgMove && this.imageBank.maximized == true) {
                this.minimize();
            }
        });

        this._scope.$on('imageBank:image:closed', () => {
            this.infoActive = false;
        });
    }

    toggle(full) {
        this.imageBank.visible = ! this.imageBank.visible;

        if (full && full == true) {
            this.imageBank.maximized = true;
            $('body').css('overflow-y', 'hidden')
        } else {
            this.imageBank.maximized = false;
            $('body').css('overflow-y', 'inherit')
        }

        this._timeout(() => {
            this.constructor.calcHeightForImageAndDirectoryContainer();
        }, 400);

        this.fetchImagesAndDirectories(this.imageBank.page, this.imageBank.directory.id);
    }

    static calcHeightForImageAndDirectoryContainer() {
        let height = $('.images').css('height');
        let containerHeight = parseInt(height.substring(0, height.length - 2)) - 130;
        $('.image-container').css('height', containerHeight);

        height = $('.directories').css('height');
        containerHeight = parseInt(height.substring(0, height.length - 2)) - 130;
        $('.directories-container').css('height', containerHeight);
    };

    move(imgId, dirId) {
        this.imageBankRepo.move(this.imageBank.images[imgId].id, dirId, this.imageBank.directory.id).then(() => {
            this.fetchImagesAndDirectories(this.imageBank.page, this.imageBank.directory.id);
        });
    };

    validateFiles(files) {
        var deferred = this._q.defer();
        this.imageBank.validated = [];
        angular.forEach(files, (file, $i) => {
            var fileSize = file.size / 1024; //KB

            if (_.indexOf(this.VALID_FORMATS, file.type) == -1) {
                this.generateMessage('mime_type_err', 'error');
            } else if (fileSize > this.MAX_FILE_SIZE) { // Best to catch frontend
                this.generateInputMessage('file_size_err', 'warning').then(() => {
                    if (this.imageBank.confirmation) {
                        this.imageBank.validated.push(file);

                        if ($i == files.length - 1) {
                            deferred.resolve();
                        }
                    }
                });
            } else {
                this.imageBank.validated.push(file);
                if ($i == files.length - 1) {
                    deferred.resolve();
                }
            }
        });

        return deferred.promise;
    };

    fetchImagesAndDirectories(page, dir) {
        this.imageBankRepo.all({ page: page, full: this.imageBank.maximized, directory: dir }).then((imageBank) => {
            this.imageBank.page = page;
            this.imageBank.directories = imageBank.directories;
            this.imageBank.images = imageBank.images.data;
            this.imageBank.pages = imageBank.images.meta['pagination']['total_pages'];
            this.imageBank.publicS3Path = imageBank.publicS3Path;
        })
    };

    updateUI() {
        this.fetchImagesAndDirectories(this.imageBank.page, this.imageBank.directory.id);
    };

    generateInputMessage(message, type) {
        let deferred = this._q.defer();

        this.sweetAlert.swal({
            title: this._translator(this.msgMap[message][0]),
            text: this._translator(this.msgMap[message][1]),
            type: type,
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO')
        }, (isConfirm) => {
            this.imageBank.confirmation = isConfirm;
            deferred.resolve();
        });

        return deferred.promise;
    };

    generateMessage(message, type) {
        this.sweetAlert.swal({
            title: this._translator(this.msgMap[message][0]),
            text: this._translator(this.msgMap[message][1]),
            type: type,
            confirmButtonText: this._translator('GLOBAL:OK')
        });
    };

    changeOrRenameDirectory(dir, event) {
        if (this.imageBank.editMode && ! $(event.target).is('.remove-btn')) {
            this.imageBank.editDir = dir;
        } else if (dir === 0) {
            return this.toRoot();
        } else if (! this.imageBank.editMode) {
            this.imageBankRepo.getDirectory(dir).then((response) => {
                this.imageBank.directory = response;
                this.fetchImagesAndDirectories(1, this.imageBank.directory.id);
            });
        }
    };

    toRoot() {
        this.imageBank.directory.id = 0;
        this.fetchImagesAndDirectories(1, 0);
    };

    close() {
        $('body').css('overflow-y', 'inherit'); // Enable page scroll again.
        this.imageBank.visible = false;
        this._scope.$broadcast('imageBank:close');
    };

    expand() {
        this.imageBank.maximized = true;
        $('body').css('overflow-y', 'hidden');
        $('.image-bank > .full').css('display', 'block');

        this._timeout(() => {
            this.constructor.calcHeightForImageAndDirectoryContainer();
        }, 400);

        this.fetchImagesAndDirectories(1, this.imageBank.directory.id);
    };

    minimize() {
        this.imageBank.maximized = false;
        $('body').css('overflow-y', 'inherit');
        this.fetchImagesAndDirectories(1, 0);
    };

    prevPage() {
        this.imageBank.page--;
        this.fetchImagesAndDirectories(this.imageBank.page, this.imageBank.directory.id);
    };

    nextPage() {
        this.imageBank.page++;
        this.fetchImagesAndDirectories(this.imageBank.page, this.imageBank.directory.id);
    };

    toggleMoveImgs() {
        this.imageBank.imgMove = ! this.imageBank.imgMove;
        this.imageBank.dragActive = false;
    };

    deleteImg(image) {
        this.generateInputMessage('remove_img', 'warning').then(() => {
            if (this.imageBank.confirmation) {
                this.imageBankRepo.destroy(image.id).then(() => {
                    this.fetchImagesAndDirectories(1, this.imageBank.directory.id);
                }, (error) => {
                    this.generateMessage('delete_error', 'error');
                })
            }
        });
    };

    deleteDir(directory) {
        this.generateInputMessage('delete_dir', 'warning').then(() => {
            if (this.imageBank.confirmation) {
                this.imageBankRepo.destroyDirectory(directory.id).then(() => {
                    this.fetchImagesAndDirectories(1, this.imageBank.directory.id);
                });
            }
        });
    };

    updateFolderName(newName, directory) {
        if (newName && newName.length > 0) {
            this.imageBank.editDir = false;
            this.imageBank.tmpName = "";
            directory.name = newName;

            this.imageBankRepo.setDirectoryName(directory).then(() => {
                if (directory.id == this.imageBank.directory.id) {
                    this.imageBank.directory.name = newName; // Update UI
                }
            })
        }
    };

    createDirectory() {
        this.imageBank.newDirectory = false;

        this.imageBankRepo.storeDirectory(this.imageBank.newDirName).then(() => {
            this.imageBank.newDirName = null;
            this.fetchImagesAndDirectories(1, this.imageBank.directory.id);
        });
    };

    edit(image, index) {
        this.imageBank.originalPosition = index;
        this.imageBank.parentId = image.id;
        const imagePath = this.imageBank.publicS3Path + "/"  + image.filename;
        const imgElement = angular.element('<img id="editImg" src="' + imagePath + '" />');

        this._scope.$emit('event:upload.image.to.edit', {
            imageURL: imagePath,
            directory: this.imageBank.directory.id
        });
    };

    info(image) {
        this.infoActive = true;
        this._scope.$broadcast('imageBank:image:showInfo', { image: image, publicPath: this.imageBank.publicS3Path });
    };
}
